import { Tag, TagProps, Tooltip } from "@chakra-ui/react";
import React from "react";

type IncompleteBadgeProps = {
  size?: "sm" | "md" | "lg";
  variant?: "solid" | "outline" | "subtle";
} & TagProps;

const IncompleteBadge: React.FC<IncompleteBadgeProps> = ({
  size = "sm",
  variant = "solid",
  ...props
}) => {
  return (
    <Tooltip
      label="This interview is incomplete and has not been evaluated yet"
      placement="top"
    >
      <Tag
        bg="orange.100"
        color="orange.700"
        variant={variant}
        size={size}
        {...props}
      >
        INCOMPLETE
      </Tag>
    </Tooltip>
  );
};

export default IncompleteBadge;
